import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Simple centered spinner shown while tournament data (groups / main / paguoda)
// is being fetched. Intentionally minimal — the exact page shape differs
// between tabs (group tables vs brackets), so a neutral spinner fits all.
const BracketLoader = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '80px 0',
      }}
    >
      <CircularProgress
        size={40}
        thickness={4}
        sx={{
          color: theme.palette.darkGrey?.[400] || '#9E9E9E',
        }}
      />
    </Box>
  );
};

export default BracketLoader;
